import { Tooltip } from '@material-ui/core'
import React, { useRef, useState } from 'react'

/** Props for {@link TruncatedLabel}. */
export interface TruncatedLabelProps {
    /** The text to display and show in the tooltip when truncated. */
    text: string
    /** CSS class applied to the span (caller controls overflow/ellipsis styling). */
    className: string
    /** Optional CSS class applied to the tooltip popup itself. */
    tooltipClassName?: string
}

/**
 * Renders text that shows a tooltip only when the element is actually truncated
 * (scrollWidth > offsetWidth). Avoids unnecessary tooltips on short labels.
 */
const TruncatedLabel = ({
    text,
    className,
    tooltipClassName,
}: TruncatedLabelProps) => {
    const ref = useRef<HTMLSpanElement>(null)
    const [open, setOpen] = useState(false)
    return (
        <Tooltip
            title={text}
            open={open}
            placement="top"
            classes={
                tooltipClassName ? { tooltip: tooltipClassName } : undefined
            }
        >
            <span
                ref={ref}
                className={className}
                onMouseEnter={() => {
                    const el = ref.current
                    if (el && el.scrollWidth > el.offsetWidth) setOpen(true)
                }}
                onMouseLeave={() => setOpen(false)}
            >
                {text}
            </span>
        </Tooltip>
    )
}

export default TruncatedLabel
